import { SVGProps } from 'react';

export default function DotsIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      className="dots"
      width="46"
      height="32"
      viewBox="0 0 46 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="5" cy="5" r="5" fill="white" />
      <circle cx="23" cy="5" r="5" fill="white" />
      <circle cx="41" cy="5" r="5" fill="white" />
    </svg>
  );
}
